/**
 * Promand Header v2
 */
(function () {
  'use strict';

  const header = document.querySelector('[data-promand-header]');
  if (!header) return;

  const desktopQuery = window.matchMedia('(min-width: 1180px) and (hover: hover)');

  /* Sticky */
  if (header.classList.contains('promand-header--smart')) {
    let last = 0;
    let ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        const y = window.pageYOffset || 0;
        const open = header.querySelector('.is-open, .promand-header__drawer.is-open');
        if (!open && y > last && y > 90) header.classList.add('is-hidden');
        else header.classList.remove('is-hidden');
        last = y < 0 ? 0 : y;
        ticking = false;
      });
    }, { passive: true });
  }

  /* Drawer */
  const drawer = header.querySelector('[data-mobile-drawer]');
  const burger = header.querySelector('[data-mobile-toggle]');
  const closeDrawerBtn = header.querySelector('[data-mobile-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    if (!document.querySelector('.promand-advanced.is-open')) document.body.style.overflow = '';
  }
  if (burger) burger.addEventListener('click', openDrawer);
  if (closeDrawerBtn) closeDrawerBtn.addEventListener('click', closeDrawer);
  if (drawer) drawer.addEventListener('click', function (e) { if (e.target === drawer) closeDrawer(); });

  /* Mega: hover on desktop, click on touch. Never block the destination URL after open. */
  const items = header.querySelectorAll('.promand-header__item.has-mega');
  items.forEach(function (item) {
    const trigger = item.querySelector('[data-mega-trigger]');
    if (!trigger) return;

    item.addEventListener('mouseenter', function () {
      if (!desktopQuery.matches) return;
      items.forEach(function (other) { if (other !== item) other.classList.remove('is-open'); });
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    });
    item.addEventListener('mouseleave', function () {
      if (!desktopQuery.matches) return;
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    });

    trigger.addEventListener('click', function (e) {
      if (desktopQuery.matches) return; /* hover devices: let the link work */
      if (!item.classList.contains('is-open')) {
        e.preventDefault();
        items.forEach(function (other) { other.classList.remove('is-open'); });
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (!header.contains(e.target)) {
      items.forEach(function (item) {
        item.classList.remove('is-open');
        const t = item.querySelector('[data-mega-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* Search + predictive */
  const searchRoot = header.querySelector('[data-search-root]');
  const searchToggle = header.querySelector('[data-search-toggle]');
  const searchInput = header.querySelector('[data-predictive-input]');
  const resultsBox = header.querySelector('[data-predictive-results]');
  let searchTimer = null;

  function openMobileSearch() {
    if (!searchRoot) return;
    searchRoot.classList.add('is-open');
    if (searchInput) searchInput.focus();
  }
  if (searchToggle) searchToggle.addEventListener('click', openMobileSearch);

  document.addEventListener('keydown', function (e) {
    if (e.key === '/' && document.activeElement && !/INPUT|TEXTAREA/.test(document.activeElement.tagName)) {
      e.preventDefault();
      if (searchInput) searchInput.focus();
    }
    if (e.key === 'Escape') {
      closeDrawer();
      closeAdvanced();
      if (resultsBox) resultsBox.hidden = true;
    }
  });

  function renderPredictive(data) {
    if (!resultsBox) return;
    const products = (((data.resources || {}).results || {}).products) || [];
    const collections = (((data.resources || {}).results || {}).collections) || [];
    const pages = (((data.resources || {}).results || {}).pages) || [];
    if (!products.length && !collections.length && !pages.length) {
      resultsBox.innerHTML = '<p class="promand-header__predictive-empty">No suggestions</p>';
      resultsBox.hidden = false;
      return;
    }
    let html = '';
    products.slice(0, 6).forEach(function (p) {
      const img = p.image || p.featured_image || '';
      html += '<a href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="">' : '') + '<span>' + (p.title || '') + '</span></a>';
    });
    collections.slice(0, 3).forEach(function (c) {
      html += '<a href="' + c.url + '"><span>' + (c.title || '') + '</span></a>';
    });
    pages.slice(0, 2).forEach(function (p) {
      html += '<a href="' + p.url + '"><span>' + (p.title || '') + '</span></a>';
    });
    resultsBox.innerHTML = html;
    resultsBox.hidden = false;
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      const q = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) {
        if (resultsBox) resultsBox.hidden = true;
        return;
      }
      searchTimer = setTimeout(function () {
        const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page&resources[limit]=8';
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) { if (data) renderPredictive(data); })
          .catch(function () {});
      }, 180);
    });
    searchInput.addEventListener('blur', function () {
      setTimeout(function () { if (resultsBox) resultsBox.hidden = true; }, 200);
    });
  }

  /* Advanced modal */
  const advanced = document.querySelector('[data-advanced-modal]');
  function openAdvanced() {
    if (!advanced) return;
    advanced.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    closeDrawer();
  }
  function closeAdvanced() {
    if (!advanced) return;
    advanced.classList.remove('is-open');
    if (!drawer || !drawer.classList.contains('is-open')) document.body.style.overflow = '';
  }
  header.querySelectorAll('[data-advanced-toggle]').forEach(function (btn) {
    btn.addEventListener('click', openAdvanced);
  });
  if (advanced) {
    advanced.querySelectorAll('[data-advanced-close]').forEach(function (btn) {
      btn.addEventListener('click', closeAdvanced);
    });
    const form = advanced.querySelector('[data-advanced-form]');
    if (form) {
      form.addEventListener('submit', function () {
        const q = form.querySelector('[data-advanced-q]');
        if (!q) return;
        const extras = [];
        form.querySelectorAll('[data-adv-term]:checked').forEach(function (box) {
          extras.push(box.value);
        });
        if (extras.length) {
          q.value = (q.value + ' ' + extras.join(' ')).trim();
        }
      });
    }
  }
  document.querySelectorAll('[data-advanced-toggle]').forEach(function (btn) {
    if (!header.contains(btn)) btn.addEventListener('click', openAdvanced);
  });

  /* Cart count */
  function setCount(n) {
    header.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = String(n);
      el.classList.toggle('is-empty', Number(n) === 0);
    });
  }
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart && typeof cart.item_count !== 'undefined') setCount(cart.item_count); })
      .catch(function () {});
  }
  ['cart:updated', 'cart:change', 'cart:refresh', 'theme:cart:change'].forEach(function (name) {
    document.addEventListener(name, refreshCart);
  });
  document.addEventListener('ajaxCart:updated', refreshCart);
})();
